export default __webpack_public_path__ + "a0c4ec60d4900869e54f6a7d28d39be5.png";